import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from '@/contexts/AuthContext'

/** Access auth context — throws if used outside <AuthProvider> */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth must be used inside <AuthProvider>')
  }
  return ctx
}

/** True se l'utente loggato NON è un cliente (operatore o admin).
 *  Le azioni da cliente (prenotazioni, quiz matching, preferiti) sono
 *  riservate al ruolo USER — il backend risponde 403 negli altri casi. */
export function useIsNonClient(): boolean {
  const { isAuthenticated, user } = useAuth()
  return isAuthenticated && !!user && user.role !== 'USER'
}
